import React, { useId, useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export default function PasswordField({
  label,
  value,
  onChange,
  autoComplete,
  required = true,
  minLength,
  className = "",
  labelClassName = "",
  children,
}) {
  const inputId = useId();
  const [visible, setVisible] = useState(false);

  return (
    <div className={className}>
      <label htmlFor={inputId} className={`block text-sm ${labelClassName}`}>{label}</label>
      <div className="relative mt-2">
        <input
          id={inputId}
          className="input-underline w-full pr-11"
          type={visible ? "text" : "password"}
          value={value}
          onChange={onChange}
          required={required}
          minLength={minLength}
          autoComplete={autoComplete}
        />
        <button
          type="button"
          className="absolute right-0 top-1/2 -translate-y-1/2 p-2 text-[--muted-foreground] hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
          onClick={() => setVisible((current) => !current)}
          aria-label={visible ? "Hide password" : "Show password"}
          aria-pressed={visible}
          title={visible ? "Hide password" : "Show password"}
        >
          {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </div>
      {children}
    </div>
  );
}